<template>
    <div style="position: relative">
        <el-button v-if="multipleSelection.length > 0 && draggable" @click="handleSorteableMultiple()"><i class="el-icon-d-caret"></i></el-button>        
        <el-button v-if="multipleSelection.length > 0 && sidebar && isAdmin"  @click="handleSidebarMultiple(1)">Mostrar en menú</el-button>
        <el-button v-if="multipleSelection.length > 0 && sidebar && isAdmin"  type="info" @click="handleSidebarMultiple(0)">No mostrar en menú</el-button>
        <el-button v-if="multipleSelection.length > 0 && isAdmin" type="danger" @click="handleDeleteMultiple()">Eliminar registros</el-button>
        
        <el-button v-if="search" class="btn--custom-mini custom--search"  size="mini"  @click="hamdleSearch()"> <i class="el-icon-search"></i> </el-button>

        <el-form ref="form" size="mini" :label-position="'left'" label-width="125px" v-if="showSearch" class="custom--input--search">
            <el-form-item >
                <el-input
                        placeholder="Busqueda"
                        prefix-icon="el-icon-search"
                        v-model="searchQuery"
                        name="buscador">
                </el-input>
            </el-form-item>
        </el-form>  
        <el-table :data="tableData" ref="multipleTable" :class="customclass" @selection-change="handleSelectionChange" >
            <el-table-column  v-if="multipleSelect" type="selection" width="55"></el-table-column>
            <el-table-column v-for="(c, i) in tableColumns" :key="i" :prop="c.prop" :label="c.label" v-if="c.label == 'Icono'" width="90">
                <template slot-scope="scope" >
                    <i :class="scope.row.icono" ></i>
                </template>
            </el-table-column>
            <el-table-column v-for="(c, i) in tableColumns" :key="i" :prop="c.prop" :label="c.label" v-if="c.label == 'Nombre'">
                  <template slot-scope="scope">
                    <el-popover trigger="hover" placement="top" v-if="scope.row.descripcion">
                        <p>{{ scope.row.descripcion }}</p>
                        <div slot="reference" class="name-wrapper">
                            <el-tag size="medium">{{ scope.row.nombre }}</el-tag>
                        </div>
                    </el-popover>
                    <div class="cell" v-else>{{ scope.row.nombre }}</div>
                </template>
            </el-table-column>

            <el-table-column v-for="(c, i) in tableColumns" :key="i" :prop="c.prop" :label="c.label" v-if="c.label == 'Menú'">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.visible == 'No'" type="info">{{ scope.row.visible }}</el-tag>
                    <div v-else class="cell">{{ scope.row.visible }}</div>
                </template>
            </el-table-column>

            <el-table-column v-for="(c, i) in tableColumns" :key="i" :prop="c.prop" :label="c.label" v-if="c.label == 'Proyecto'">
                  <template slot-scope="scope">
                    <div class="cell pointer" @click.prevent="handleSelect(i, scope.row)">{{ scope.row.proyecto }}</div>
                </template>
            </el-table-column>

            <el-table-column v-for="(c, i) in tableColumns" :key="i" :prop="c.prop" :label="c.label" sortable v-if="c.label != 'Icono' && c.label != 'Nombre' && c.label != 'Menú' && c.label != 'Proyecto'" ></el-table-column>
            <el-table-column label="Acciones">
                <template slot-scope="scope" width="200" fixed="right">
                    <el-button v-if="routeSelect" class="btn--custom-mini btn--custom-hover"  size="mini"  @click="handleSelect(scope.$index, scope.row)"> <i class="el-icon-zoom-in"></i> </el-button>
                    <el-button v-if="routeView"   class="btn--custom-mini"  size="mini"  type="info" @click="handleView(scope.row)"> <i class="el-icon-view"></i> </el-button>
                    <el-button v-if="routeEdit"   class="btn--custom-mini"  size="mini" @click="handleEdit(scope.$index, scope.row)"> <i class="el-icon-edit"></i> </el-button>
                    <el-button v-if="routeDelete" class="btn--custom-mini"  size="mini" type="danger" @click="handleDelete(scope.$index, scope.row)"> <i class="el-icon-delete"></i> </el-button>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination v-if="totalRegistros > itemsPorPagina"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page.sync="currentPage"
            layout="total, sizes, prev, pager, next"
            :total="totalRegistros">
        </el-pagination>
    </div>
</template>

<script>
    import { API_UPLOADS } from "@/common/config";
    import { mapGetters } from "vuex"

    export default {
        name: 'tablaConPaginador',
        props: [
            'routeEdit', 
            'tableQuery',
            'tableColumns', 
            'routeDelete', 
            'routeView', 
            'routeSelect', 
            'items',
            'sidebar', 
            'multipleSelect', 
            'draggable', 
            'customclass',
            'search' // Activa el buscador
        ],
        created () {
            this.init()
        },
        data () {
            return {
                currentPage: 1,
                totalRegistros: null,
                itemsPorPagina: 20,
                tableData: [],
                row: null,
                multipleSelection: false,
                api_uploads: API_UPLOADS,
                activeRow: null,
                searchQuery: '',
                showSearch: false
            }
        },
        watch: {
            searchQuery (v, a){
                this.searchInTable()
            }
        },
        methods: {
            init (){
                this.items ? this.itemsPorPagina = this.items : false;
                setTimeout(() => {this.tableData = this.paginador() }, 100);
            },
            paginador() {
                const indiceInicio = (this.currentPage - 1) * this.itemsPorPagina;
                const indiceFinal =
                    indiceInicio + this.itemsPorPagina > this.tableQuery.length
                    ? this.tableQuery.length
                    : indiceInicio  + this.itemsPorPagina;
                this.totalRegistros = this.tableQuery.length
                return this.tableQuery.slice(indiceInicio , indiceFinal);
            },
            handleSizeChange(val) {
                this.itemsPorPagina = val
                this.tableData = this.paginador()
            },
            handleCurrentChange(val) {
                this.currentPage = val
                this.tableData = this.paginador()
            },
            handleSelectionChange(val) {
                this.multipleSelection = val
            },
            handleEdit(index, row) {
                this.$root.$emit('isConnect')
                
                if(this.routeEdit != 'modal') {
                    row.templateId
                        ? this.$router.push(this.routeEdit + row.id + '/' + row.templateId )
                        : this.$router.push(this.routeEdit + row.id ) ;
                }else{
                    this.$root.$emit('openModal', row.id)
                }
            },
            handleSelect(index, row){
                this.$root.$emit('isConnect')
                this.activeRow = row.id
                this.$root.$emit('select', row.id, row)
            },
            handleView(row){
                this.$root.$emit('isConnect')
                this.$router.push(this.routeView + row.id )
            },
            handleDelete(index, row) {
                this.$root.$emit('isConnect')                
                this.$confirm('Esto eliminará permanentemente el registro. ¿Continuar?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                    }).then(() => {
                        this.$root.$emit('delete', row.id, row)
                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: 'Se ha cancelado el borrado'
                    });
                })
            },
            handleSidebarMultiple(value){
                this.$root.$emit('isConnect')                
                this.multipleSelection.forEach(element => {
                    this.$root.$emit('sidebarUpdate', element.id, element, value)
                })
            },
            handleSorteableMultiple(){
                this.$root.$emit('isConnect')                
                this.$root.$emit('showmodaldraggable')
            },
            handleDeleteMultiple(){
                this.$root.$emit('isConnect')                
                this.$confirm('Esto eliminará permanentemente los registros marcados. ¿Continuar?', 'Warning', {
                    confirmButtonText: 'OK',
                    cancelButtonText: 'Cancel',
                    type: 'warning'
                    }).then(() => {
                        if(this.routeDelete){
                            this.multipleSelection.forEach(element => {
                                this.$root.$emit(this.routeDelete, element.id, element)
                            })
                        }else{
                            this.multipleSelection.forEach(element => {
                                this.$root.$emit('delete', element.id, element)
                            })
                        }

                    }).catch(() => {
                        this.$message({
                            type: 'info',
                            message: 'Se ha cancelado el borrado'
                    });
                })

            },
            tableRowClassName(row) {
                if(row.id == this.activeRow){
                    return 'success-row'
                }
            },
			searchInTable() {
                if(this.searchQuery){
                    this.itemsPorPagina = this.tableQuery.length
                    this.tableData = this.tableQuery.filter( e => {
					    return this.tableColumns.some( p => {
                            if(e[p.prop] != null &&  typeof e[p.prop] === 'string' && e[p.prop]){
                                return e[p.prop].toLowerCase().includes(this.searchQuery.toLowerCase())
                            }
                        })
                    })
                }else{
                    this.tableShow = false
                    this.init()
                }
            },
            hamdleSearch(){
                this.$root.$emit('isConnect')                
                this.showSearch = !this.showSearch
            }
        },
        computed: {
            ...mapGetters(['isAdmin'])
		},
    }
</script>
<style scoped>
    .ionicons {
        font-size: 21px !important;
    }
    .el-table .success-row {
        background: #f0f9eb;
    }
    .btn--custom-mini {
        padding: 7px;
    }
    .btn--custom-hover:focus, .btn--custom-hover:hover, .btn--custom-hover:active{
        color: #ffffff;
        border-color: #909399;
        background-color: #909399;
    }
    .pointer{
        cursor: pointer;
    }
    .custom--input--search,
    .custom--search {
        position: absolute;
        z-index: 99;
        top: 6px;
        right: 10px;
    }
    .custom--search {
        margin: 0!important;
        height: 28px;
    }
    .custom--input--search{
        width: 100%;
        z-index: 98;
    }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/commons/tablaConPaginador.vue